var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useState } from 'react';
import { StepIcon } from './StepIcon';
import useStyle from './StepStyles';
import SubStep from './SubStep';
var Step = function (_a) {
    var currentSubStep = _a.currentSubStep, index = _a.index, isCurrentStep = _a.isCurrentStep, isExpanded = _a.isExpanded, isFirst = _a.isFirst, isLast = _a.isLast, isMobile = _a.isMobile, isRtl = _a.isRtl, name = _a.name, onClick = _a.onClick, generateLabel = _a.generateLabel, render = _a.render, showStepNumber = _a.showStepNumber, status = _a.status, subHeading = _a.subHeading, subSteps = _a.subSteps, disabled = _a.disabled;
    var _b = __read(useState(false), 2), hover = _b[0], setHover = _b[1];
    var _c = useStyle({
        isRtl: isRtl,
        isCurrentStep: isCurrentStep,
        status: status,
        hover: hover,
        collapsed: !!isMobile && !isExpanded
    }), main = _c.main, stepWrapper = _c.stepWrapper, stepContainer = _c.stepContainer, nameWrapper = _c.nameWrapper, topSpacer = _c.topSpacer, bottomSpacer = _c.bottomSpacer, subHeadingWrapper = _c.subHeadingWrapper, button = _c.button;
    var showSubSteps = subSteps && subSteps.length && isCurrentStep;
    var SubHeadingSection = function () {
        if (subHeading && !isMobile) {
            return _jsx("div", __assign({ css: subHeadingWrapper }, { children: subHeading }), void 0);
        }
        return null;
    };
    return (_jsx("div", __assign({ css: stepWrapper, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }, { children: _jsxs("div", __assign({ css: main }, { children: [!isFirst && _jsx("div", { css: topSpacer }, void 0),
                _jsx("button", __assign({ disabled: disabled, type: "button", onClick: onClick, "aria-label": generateLabel &&
                        generateLabel({
                            status: status,
                            isCurrentStep: isCurrentStep,
                            isRtl: isRtl,
                            name: name,
                            disabled: disabled,
                            index: index,
                            showStepNumber: showStepNumber
                        }), css: button }, { children: _jsxs("div", __assign({ css: stepContainer }, { children: [render &&
                                render(_jsx(StepIcon, { status: status, hover: hover, showStepNumber: showStepNumber, index: index, isSelected: isCurrentStep }, void 0), _jsx("span", __assign({ css: nameWrapper }, { children: name }), void 0)),
                            !render && (_jsxs(Fragment, { children: [_jsx(StepIcon, { status: status, hover: hover, showStepNumber: showStepNumber, index: index, isSelected: isCurrentStep }, void 0),
                                    _jsx("span", __assign({ css: nameWrapper }, { children: name }), void 0)] }, void 0)),
                            _jsx(SubHeadingSection, {}, void 0)] }), void 0) }), void 0),
                (!isLast || showSubSteps) && _jsx("div", { css: bottomSpacer }, void 0),
                showSubSteps &&
                    subSteps &&
                    subSteps.map(function (step) { return (_jsx(SubStep, { isRtl: isRtl, subStep: step, isCurrentSubStep: currentSubStep === step.id }, step.id || step.name)); })] }), void 0) }), void 0));
};
export default Step;
